import React from "react";
import PropTypes from "prop-types";
import { Col, Row, Form, Label } from "reactstrap";
import shallow from "zustand/shallow";
import useCurrentRecapStore from "stores/RecapStore";
import useCurrentSaleStore from "stores/SaleStore";
import {
	PercentInput,
	CurrencyInput,
} from "features/forms/components/InputElement";

/**
 * ReserveCalculatorModal component to display and manage the reserve calculations.
 * Utilizes Reactstrap for layout and styling.
 *
 * @component
 * @returns {JSX.Element} The rendered component
 */
const ReserveCalculatorModal = () => {
	const { reserve, reservePercent, editReserve, editReservePercent } =
		useCurrentRecapStore((state) => state, shallow);

	const { amtFinanced, editReserveFlag } = useCurrentSaleStore(
		(state) => state,
		shallow
	);

	/**
	 * Handles reserve value changes.
	 * @param {number} val - The new reserve value.
	 */
	const reserveHandler = (val) => {
		editReserveFlag(false);
		editReservePercent(val / amtFinanced);
		editReserve(val);
	};

	/**
	 * Handles reserve percentage changes.
	 * @param {number} val - The new reserve percentage value.
	 */
	const reservePercentHandler = (val) => {
		editReserveFlag(true);
		editReservePercent(val);
	};

	return (
		<Form>
			<Row>
				<CurrencyInput
					label="Amount Financed"
					value={amtFinanced}
					readOnly
					disableValidation
					wholeRow
				/>
				<PercentInput
					label="Reserve %"
					value={reservePercent}
					onChange={reservePercentHandler}
					disableValidation
					wholeRow
				/>
				<CurrencyInput
					label="Reserve Amount"
					value={reserve}
					onChange={reserveHandler}
					disableValidation
					wholeRow
				/>
			</Row>
		</Form>
	);
};

ReserveCalculatorModal.propTypes = {
	reserve: PropTypes.number.isRequired,
	reservePercent: PropTypes.number.isRequired,
	editReserve: PropTypes.func.isRequired,
	editReservePercent: PropTypes.func.isRequired,
	amtFinanced: PropTypes.number.isRequired,
	editReserveFlag: PropTypes.func.isRequired,
};

export default ReserveCalculatorModal;
